function setUrlHash(name, value) {
    var originUrl = location.href.split('#')[0];
    var otherPairs = [];
    if (window.location.hash) {
        var hash = window.location.hash.substring(1);
        var items = hash.split('&');
        var i;
        for (i = 0; i < items.length; i++) {
            var pair = items[i].split('=');
            if (pair[0] !== name) {
                otherPairs.push(pair);
            }
        }
    }
    var reportStatePair = [name, encodeURIComponent(value)];
    var newHash = otherPairs.concat([reportStatePair]).map(function (pair) {
        return pair[0] + '=' + pair[1];
    }).join('&');

    window.history.pushState(history.state, document.title, originUrl + '#' + newHash);
}

function getUrlHash(name) {
    if (window.location.hash) {
        var hash = window.location.hash.substring(1);
        var items = hash.split('&');
        var i;
        for (i = 0; i < items.length; i++) {
            var pair = items[i].split('=');
            if (pair[0] === name) {
                return decodeURIComponent(pair[1]);
            }
        }
    }
    return '';
}

export {
    setUrlHash,
    getUrlHash
}

export default {
    setItem: setUrlHash,
    getItem: getUrlHash
}
